<template>


 <div class="profile d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="listing-navbar bg-primary d-flex align-items-center gap-3 shadow-sm mb-auto p-3">
            <a @click="goBack()"><i class="bi bi-arrow-left text-white fs-5"></i></a>
            <a href="#" class="text-white" data-bs-toggle="modal" data-bs-target="#categories">
               <div class="d-flex align-items-center gap-2">
                  <!-- <img src="img/delivery-boy.jpg" alt="" class="rounded-pill img-fluid"> -->
                  <div>
                     <h6 class="fw-bold text-white mb-0">Course List</h6>
                  </div>
               </div>
            </a>
            <div class="d-flex align-items-center gap-2 ms-auto">

            </div>
         </div>

 <main class="dashboard-main">
  <div class="container-fluid">
    <!-- Stats Overview -->

    <!-- Available Courses -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="section-header d-flex justify-content-between align-items-center mb-3">
          <h4 class="section-title">All Courses</h4>
         
        </div>
        <div class="row g-3">
          <div v-for="(course, index) in filteredCourses" :key="course.id" class="col-12">
            <div class="course-card">
              <router-link :to="'/course?id=' + course.id" class="course-link">
                <div class="course-img-wrapper">
                  <img :src="course.image || '/src/assets/img/category-1.png'" :alt="course.name" class="course-img">
                  <div class="course-badge" v-if="course.status === 'coming-soon'">Coming Soon</div>
                </div>
                <div class="course-content">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    <h6 class="course-title">{{ course.name }}</h6>
                    <span class="lessons-count">{{ course.lessons }} lessons</span>
                  </div>
                  <p class="course-desc" v-if="course.description">{{ stripTags(course.description.substring(0, 60)) }}...</p>
                  <div class="course-footer">
                    <div class="price-wrapper">
                      <del class="original-price" v-if="course.mrp">₹{{ course.mrp }}</del>
                      <span class="current-price">₹{{ course.cost || course.price }}</span>
                    </div>
                    <button class="btn btn-primary btn-sm">Details</button>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  </main>
 





  </div>
</template>

<style scoped>
.dashboard-page {
  min-height: 100vh;
  background-color: #f8fafc;
  transition: all 0.3s ease;
}

.dark-mode {
  background-color: #0f172a;
  color: #e2e8f0;
}

/* Theme Toggle */
.theme-toggle {
  position: fixed;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 1000;
}

.theme-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #4f46e5;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.dark-mode .theme-btn {
  background: rgba(15, 23, 42, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
}

.theme-btn:hover {
  transform: rotate(15deg);
  background: rgba(255, 255, 255, 1);
}

.dark-mode .theme-btn:hover {
  background: rgba(15, 23, 42, 1);
}

/* Header */
.dashboard-header {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
}

.dark-mode .dashboard-header {
  background: rgba(15, 23, 42, 0.8);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* User Profile */
.user-profile {
  padding: 0.5rem 0;
}

.avatar-wrapper {
  position: relative;
}

.avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #4f46e5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

/* Search */
.search-wrapper {
  position: relative;
}

.search-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #64748b;
  transition: all 0.3s ease;
}

.search-btn:hover {
  background: #f1f5f9;
  color: #4f46e5;
}

.dark-mode .search-btn:hover {
  background: #1e293b;
}

.search-expanded {
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  background: white;
  border-radius: 24px;
  padding: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  z-index: 10;
}

.dark-mode .search-expanded {
  background: #1e293b;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.search-expanded .form-control {
  border: none;
  background: transparent;
  padding: 0.25rem 0.5rem;
}

.dark-mode .search-expanded .form-control {
  color: #e2e8f0;
}

.btn-close-search {
  background: transparent;
  border: none;
  color: #64748b;
  padding: 0.25rem;
}

/* Buttons */
.btn-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #64748b;
  position: relative;
  transition: all 0.3s ease;
}

.btn-icon:hover {
  background: #f1f5f9;
  color: #4f46e5;
}

.dark-mode .btn-icon:hover {
  background: #1e293b;
}

.notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #ef4444;
  color: white;
  font-size: 0.7rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Stats Cards */
.stat-card {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
}

.dark-mode .stat-card {
  background: #1e293b;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.dark-mode .stat-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 1rem;
  flex-shrink: 0;
}

.stat-icon.bg-primary {
  background: #4f46e5;
}

.stat-icon.bg-success {
  background: #10b981;
}

.stat-icon.bg-info {
  background: #06b6d4;
}

.stat-icon.bg-warning {
  background: #f59e0b;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  color: #1e293b;
}

.dark-mode .stat-value {
  color: #e2e8f0;
}

.stat-label {
  color: #64748b;
  margin-bottom: 0;
  font-size: 0.875rem;
}

/* Section Headers */
.section-header {
  margin-bottom: 1.5rem;
}

.section-title {
  font-weight: 700;
  /* color: #fff; */
  margin-bottom: 0;
}

.dark-mode .section-title {
  color: #e2e8f0;
}

.view-all-link {
  color: #4f46e5;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
}

.view-all-link:hover {
  color: #3730a3;
}

/* Banners Carousel */
.banners-carousel {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  height: 200px;
}

.banners-track {
  display: flex;
  transition: transform 0.5s ease;
  height: 100%;
}

.banner-slide {
  flex: 0 0 100%;
  height: 100%;
}

.banner-link {
  display: block;
  height: 100%;
  text-decoration: none;
}

.banner-card {
  position: relative;
  height: 100%;
  border-radius: 16px;
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  padding: 1.5rem;
  color: white;
}

.banner-title {
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.banner-desc {
  margin-bottom: 0;
  opacity: 0.9;
}

.carousel-controls {
  display: flex;
  gap: 0.5rem;
}

/* Course Cards */
.course-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(0,0,0,0.05);
  border: 1px solid rgba(0, 0, 0, 0.1); 
}

.course-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.15);
}

.dark-mode .course-card {
  background: #1e293b;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.dark-mode .course-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.course-link {
  text-decoration: none;
  color: inherit;
  display: block;
  height: 100%;
}

.course-img-wrapper {
  position: relative;
  height: 160px;
  overflow: hidden;
}

.course-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.course-card:hover .course-img {
  transform: scale(1.05);
}

.course-badge {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  background: #f59e0b;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 500;
}

.course-content {
  padding: 1rem;
}

.course-title {
  font-weight: 600;
  margin-bottom: 0;
  color: #1e293b;
}

.dark-mode .course-title {
  color: #e2e8f0;
}

.lessons-count {
  font-size: 0.75rem;
  color: #64748b;
  flex-shrink: 0;
}

.course-desc {
  color: #64748b;
  font-size: 0.875rem;
  margin-bottom: 1rem;
}

.course-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price-wrapper {
  display: flex;
  flex-direction: column;
}

.original-price {
  font-size: 0.75rem;
  color: #94a3b8;
  text-decoration: line-through;
}

.current-price {
  font-weight: 700;
  color: #1e293b;
}

.dark-mode .current-price {
  color: #e2e8f0;
}

/* Activity List */
.activity-list {
  background: white;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.dark-mode .activity-list {
  background: #1e293b;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.activity-item {
  display: flex;
  align-items: flex-start;
  padding: 1rem 0;
  border-bottom: 1px solid #e2e8f0;
}

.dark-mode .activity-item {
  border-bottom: 1px solid #334155;
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
  color: #4f46e5;
}

.dark-mode .activity-icon {
  background: #334155;
}

.activity-content {
  flex: 1;
}

.activity-text {
  margin-bottom: 0.25rem;
  color: #1e293b;
}

.dark-mode .activity-text {
  color: #e2e8f0;
}

.activity-time {
  font-size: 0.75rem;
  color: #64748b;
}

.empty-state {
  text-align: center;
  padding: 3rem 1rem;
}

.empty-icon {
  font-size: 3rem;
  color: #cbd5e1;
  margin-bottom: 1rem;
}

.empty-text {
  font-weight: 600;
  color: #64748b;
  margin-bottom: 0.5rem;
}

.empty-subtext {
  color: #94a3b8;
  margin-bottom: 0;
}

/* Main Content */
.dashboard-main {
  padding: 2rem 0;
}

/* Responsive */
@media (max-width: 768px) {
  .dashboard-header {
    /*padding: 1rem 0;*/
  }
  
  .user-info h6 {
    font-size: 1rem;
  }
  
  .user-info small {
    font-size: 0.75rem;
  }
  
  .stat-card {
    padding: 1rem;
  }
  
  .stat-icon {
    width: 48px;
    height: 48px;
    margin-right: 0.75rem;
  }
  
  .stat-value {
    font-size: 1.25rem;
  }
  
  .banners-carousel {
    height: 160px;
  }
  
  .banner-overlay {
    padding: 1rem;
  }
  
  .banner-title {
    font-size: 1.1rem;
  }
  
  .banner-desc {
    font-size: 0.9rem;
  }
  
  .course-img-wrapper {
    height: 140px;
  }
  
  .theme-toggle {
    top: 1rem;
    right: 1rem;
  }
  
  .theme-btn {
    width: 40px;
    height: 40px;
  }
}
</style>

<script> 
import axios from "@/plugins/axios";
import { useRouter } from 'vue-router';

export default {
  name: 'Dashboard',

  data() {
    return {
      darkMode: false,
      searchQuery: '',
      showSearch: false,
      searchInput: null,
      bannerIndex: 0,

      student: {
        name: '',
        avatar: '',
        email: '',
        mobile: '',
        college: '',
        cell: ''
      },

      stats: {
        enrolledCourses: 0,
        completedLessons: 0,
        avgProgress: 0,
        studyHours: 0
      },

      banners: [],
      courses: [],
      recentActivity: [],
      enrollment_cnt:[],
      reamining_amount:[],
      completedLessons:[],
    };
  },

  computed: {
    filteredCourses() {
      if (!this.searchQuery) return this.courses;
      const query = this.searchQuery.toLowerCase();
      return this.courses.filter(course =>
        course.name.toLowerCase().includes(query) ||
        (course.description && course.description.toLowerCase().includes(query))
      );
    }
  },

  mounted() {
    const token = localStorage.getItem('token');
    if (!token) {
      this.$router.push('/login');
    }

    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      this.darkMode = savedTheme === 'dark';
    } else {
      this.darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    this.applyTheme();

    this.getHomeBasic();
  },

  methods: {
    toggleTheme() {
      this.darkMode = !this.darkMode;
      localStorage.setItem('theme', this.darkMode ? 'dark' : 'light');
      this.applyTheme();
    },

    applyTheme() {
      if (this.darkMode) {
        document.documentElement.setAttribute('data-bs-theme', 'dark');
      } else {
        document.documentElement.setAttribute('data-bs-theme', 'light');
      }
    },

    stripTags(str) {
      if (!str) return '';
      return str.replace(/<\/?[^>]+(>|$)/g, '');
    },


 

    formatTime(timeString) {
      if (!timeString) return '';
      
      const date = new Date(timeString);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);
      
      if (diffMins < 1) return 'Just now';
      if (diffMins < 60) return `${diffMins} min ago`;
      if (diffHours < 24) return `${diffHours} hr ago`;
      if (diffDays < 7) return `${diffDays} days ago`;
      
      return date.toLocaleDateString();
    },

    async getHomeBasic() {
      try {
        const response = await axios.post("getUserDetails");

        if (response.data.logged) {
          this.student = response.data.userdeatils || {};
          this.courses = response.data.courses || [];
          this.banners = response.data.banners || [];
          this.recentActivity = response.data.recentActivity || [];
          this.stats.enrolledCourses = response.data.coursescnt || 0;

           this.enrollment_cnt = response.data.enrollment_cnt || 0;
           this.reamining_amount = response.data.reamining_amount.balance|| 0;
           this.completedLessons = response.data.completedLessons.complete_seassion|| 0;

          if (response.data.laundry_details?.expired == 1) {
            localStorage.removeItem("token");
            window.location.replace("/");
          }
        } else {
          this.$router.push('/');
        }
      } catch (err) {
        console.error('Error fetching user details:', err);
      }
    },


            goBack() {
                
                this.$router.go(-1);
        },
  }
};
</script>
 